module.exports = require("github:angular/bower-angular@1.5.5/angular");